import { render, staticRenderFns } from "./PFCPModal.vue?vue&type=template&id=6746fc0c&scoped=true"
import script from "./PFCPModal.vue?vue&type=script&lang=js"
export * from "./PFCPModal.vue?vue&type=script&lang=js"
import style0 from "./PFCPModal.vue?vue&type=style&index=0&id=6746fc0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746fc0c",
  null
  
)

export default component.exports